import englishMessages from 'ra-language-english'

export const i18nEnglish = {
  ...englishMessages,
}
